import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=645ee848"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=645ee848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports